import { render } from "./VendorEdit.vue?vue&type=template&id=0015e2c5&scoped=true"
import script from "./VendorEdit.vue?vue&type=script&lang=js"
export * from "./VendorEdit.vue?vue&type=script&lang=js"

import "./VendorEdit.vue?vue&type=style&index=0&id=0015e2c5&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0015e2c5"]])

export default __exports__